var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class CustomStyle {
  constructor(key, customStyle) {
    __publicField(this, "key");
    __publicField(this, "customStyle");
    this.key = key;
    this.customStyle = customStyle;
  }
  getKey() {
    return this.key;
  }
  toCustomStyle() {
    return this.customStyle;
  }
  overrideWith(customStyle) {
    if (customStyle.key !== "empty" && this.key !== customStyle.key) {
      throw new Error(`Different keys, ${this.key} doesn't equal to ${customStyle.key}`);
    }
    return new CustomStyle(this.key, { ...this.customStyle, ...customStyle.customStyle });
  }
}
export {
  CustomStyle as default
};
//# sourceMappingURL=custom-style.js.map
